/* tslint:disable */
/* eslint-disable */
/**
 * Wire API (development)
 * The API for the Clientwire messaging service.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@clientwire.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MessageTemplateLight } from './message-template-light';
import {
    MessageTemplateLightFromJSON,
    MessageTemplateLightFromJSONTyped,
    MessageTemplateLightToJSON,
    MessageTemplateLightToJSONTyped,
} from './message-template-light';

/**
 * 
 * @export
 * @interface ConversationTypeTemplates
 */
export interface ConversationTypeTemplates {
    /**
     * The message template that should be used to render the sms text used to notify the client participants.
     * @type {MessageTemplateLight}
     * @memberof ConversationTypeTemplates
     */
    smsTemplate?: MessageTemplateLight | null;
    /**
     * The message template that should be used to render the email body used to notify the client participants.
     * @type {MessageTemplateLight}
     * @memberof ConversationTypeTemplates
     */
    emailTemplate?: MessageTemplateLight | null;
    /**
     * The message template that should be used to render the message used to request location.
     * @type {MessageTemplateLight}
     * @memberof ConversationTypeTemplates
     */
    requestLocationTemplate?: MessageTemplateLight | null;
}

/**
 * Check if a given object implements the ConversationTypeTemplates interface.
 */
export function instanceOfConversationTypeTemplates(value: object): value is ConversationTypeTemplates {
    return true;
}

export function ConversationTypeTemplatesFromJSON(json: any): ConversationTypeTemplates {
    return ConversationTypeTemplatesFromJSONTyped(json, false);
}

export function ConversationTypeTemplatesFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConversationTypeTemplates {
    if (json == null) {
        return json;
    }
    return {
        
        'smsTemplate': json['sms_template'] == null ? undefined : MessageTemplateLightFromJSON(json['sms_template']),
        'emailTemplate': json['email_template'] == null ? undefined : MessageTemplateLightFromJSON(json['email_template']),
        'requestLocationTemplate': json['request_location_template'] == null ? undefined : MessageTemplateLightFromJSON(json['request_location_template']),
    };
}

export function ConversationTypeTemplatesToJSON(json: any): ConversationTypeTemplates {
    return ConversationTypeTemplatesToJSONTyped(json, false);
}

export function ConversationTypeTemplatesToJSONTyped(value?: ConversationTypeTemplates | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sms_template': MessageTemplateLightToJSON(value['smsTemplate']),
        'email_template': MessageTemplateLightToJSON(value['emailTemplate']),
        'request_location_template': MessageTemplateLightToJSON(value['requestLocationTemplate']),
    };
}

